exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pointer{cursor:pointer}.bg-poluprovidno{background-color:hsla(0,0%,100%,.5)}.poluprovidno{opacity:.6}.ne-selektuj{user-select:none;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./game-ui/css/90-pomocno.css
// module id = 30
// module chunks = 0